// extracted by mini-css-extract-plugin
export default {"notFound":"styles_notFound__JM9xD"};